export const DOWNLOAD_PROCESS_STATEMENT_PDF_REQUEST = 'DOWNLOAD_PROCESS_STATEMENT_PDF_REQUEST';

export const downloadProcessStatementPdfFileRequest = ({ id, answerTextField }) => ({
    type: DOWNLOAD_PROCESS_STATEMENT_PDF_REQUEST,
    payload: { id, answerTextField }
});
